import { Canvas, useFrame } from '@react-three/fiber'
import Experience from './Experience.jsx'

export default function App() {

    return <Canvas
       camera={ {
           fov: 45,
           near: 0.1,
           far: 200,
           position: [ 0,1,-3 ]
       } }
       >
       <color args={ [ '#000000' ] } attach="background" />
       <Experience />
   </Canvas>
}
